// Recovered compiled webpack factory 33021. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { Wd: () => r, gb: () => n, lJ: () => s, o7: () => i });
  let r = "/editor",
    n = "/home";
  function i(e) {
    return e ? `${r}?project=${encodeURIComponent(e)}` : r;
  }
  function s(e) {
    return e ? `${r}?template=${encodeURIComponent(e)}` : r;
  }
}
